import type { ReactNode } from 'react';

interface SectionHeaderProps {
  title: string;
  /** Optional muted sub-text rendered inline after the title. */
  sub?: ReactNode;
  /** Optional action element rendered right-aligned (typically a link). */
  action?: ReactNode;
}

export function SectionHeader({ title, sub, action }: SectionHeaderProps) {
  return (
    <div className="flex items-baseline justify-between gap-3 mt-6 mb-3">
      <h2 className="text-sm font-semibold text-text flex items-baseline gap-2">
        <span>{title}</span>
        {sub != null && (
          <span className="text-xs font-normal text-muted">{sub}</span>
        )}
      </h2>
      {action && <div className="text-xs">{action}</div>}
    </div>
  );
}
